<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <!-- Action buttons -->
                <v-flex lg12 pa-0 pr-4 pt-6 pb-6>
                    <v-layout row wrap>
                        <v-switch class="pl-6" v-model="currentItem.ReceiptType" :label="currentItem.ReceiptType ? 'Phiếu chính ngạch' : 'Phiếu thường'" :true-value="1" :false-value="0" :readonly="currentItem.Status == receiptStatusEnum.da_xuat"></v-switch>
                        <v-spacer></v-spacer>
                        <v-btn @click="onPrint" v-if="currentItem.ID > 0">
                            <v-icon color="#dc3545" class="pr-2">print</v-icon>In ấn
                        </v-btn>
                        <v-btn @click="onPayment" v-if="currentItem.ID > 0 && currentItem.Status == receiptStatusEnum.chua_xuat && currentItem.Packages.length > 0 && this.currentItem.Amount > 0">
                            <v-icon color="#dc3545" class="pr-2">payment</v-icon>Thanh toán
                        </v-btn>
                        <v-btn @click="onExportStore" v-if="currentItem.ID > 0 && currentItem.Status == receiptStatusEnum.da_thanh_toan">
                            <v-icon color="#dc3545" class="pr-2">receipt</v-icon>Xuất kho
                        </v-btn>
                        <v-btn @click="saveData" v-if="currentItem.Status != receiptStatusEnum.da_xuat || adminRole">
                            <v-icon color="#dc3545" class="pr-2">save</v-icon>Cập nhật
                        </v-btn>
                    </v-layout>
                </v-flex>
                
                <!-- Thông tin cơ bản -->
                <v-flex lg3 md3 sm12>
                    <mh-date-picker plabel="Ngày xuất" class="input-group--focused date-picker" v-model="ex_date" @onChangeDate="ex_date =$event" :disabled="currentItem.Status == receiptStatusEnum.da_xuat"></mh-date-picker>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <mh-date-picker plabel="Ngày thanh toán" class="input-group--focused date-picker" v-model="pay_date" @onChangeDate="pay_date =$event" disabled></mh-date-picker>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <v-autocomplete label="Khách hàng" v-model="currentItem.UID" :items="customers" item-text="Username" item-value="ID" @change="onCustomerChanged" :readonly="currentItem.Status == receiptStatusEnum.da_xuat"></v-autocomplete>
                </v-flex> 
                <v-flex lg3 md3 sm12>
                    <v-select label="Trạng thái" v-model="currentItem.Status" :items="receiptStatus" item-text="name" item-value="value" disabled></v-select>
                </v-flex>
                
                <!-- Thông tin vận chuyển -->
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.Weight" :decimal="1" label="Cân nặng (KG)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.Volume" :decimal="2" label="Thể tích (M3)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.NumberOfPack" :decimal="0" label="Số kiện" class="input-group--focused" readonly></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <v-select label="Quy cách" v-model="currentItem.FeeType" :items="feeTypes" item-text="name" item-value="value" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></v-select>
                </v-flex>
                
                <!-- Thông tin chi phí -->
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.ExchangeRate" :decimal="0" label="Tỷ giá (₫/¥)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.FeeShip" :decimal="1" label="Phí ship TQ (¥)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.FeeShipVND" :decimal="0" label="Phí ship TQ (₫)" class="input-group--focused" disabled></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.VNFeeShip" :decimal="0" label="Phí ship VN (₫)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>

                <!-- Giá và thuế -->
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.Price" :decimal="0" label="Đơn giá vận chuyển (₫)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.Cost" :decimal="0" label="Đơn giá gốc (₫)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.ReceiptType == 1">
                    <h-currency-input v-model="currentItem.PriceOfPack" :decimal="0" label="Đơn giá mỗi kiện (₫)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <h-currency-input v-model="currentItem.Amount" :decimal="0" label="Thành tiền (₫)" class="input-group--focused" disabled></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12>
                    <v-select label="Phương thức thanh toán" v-model="currentItem.PaymentMethod" :items="paymentMethods" item-text="name" item-value="value" :readonly="currentItem.Status == receiptStatusEnum.da_xuat_thanh_toan"></v-select>
                </v-flex>
                
                <!-- Các loại thuế (chỉ cho phiếu chính ngạch) -->
                <v-flex lg3 md3 sm12 v-if="currentItem.ReceiptType == 1">
                    <h-currency-input v-model="currentItem.VatRate" :decimal="1" label="Thuế VAT (%)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.ReceiptType == 1">
                    <h-currency-input v-model="currentItem.ExportRate" :decimal="1" label="Thuế xuất khẩu (%)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.ReceiptType == 1">
                    <h-currency-input v-model="currentItem.ImportRate" :decimal="1" label="Thuế nhập khẩu (%)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex lg3 md3 sm12 v-if="currentItem.ReceiptType == 1">
                    <h-currency-input v-model="currentItem.TrusteeRate" :decimal="1" label="Phí ủy thác (%)" class="input-group--focused" :readonly="currentItem.Status == receiptStatusEnum.da_thanh_toan"></h-currency-input>
                </v-flex>
                <v-flex sm12 md12 lg12>
                    <v-widget title="Danh sách mã vận đơn">
                        <div slot="widget-header-action">
                            <v-btn small @click="openPackageDialog" v-if="currentItem.Status == receiptStatusEnum.chua_xuat && currentItem.ID > 0">
                                <v-icon color="#0f7896">add</v-icon>
                            </v-btn>
                        </div>
                        <div slot="widget-content">
                            <v-data-table fixed-header height= "70vh"  :headers="package_headers" :items="packages" disable-pagination hide-default-footer :loading="loading" v-if="currentItem.ID > 0">
                                <template v-slot:item="{ item, index }">
                                    <tr>
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.OrderTransactionCode  }}</td>
                                        <td class="text-end">{{ item.Weight | currency('', 1) }}</td>
                                        <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                                        <td class="text-center">
                                            <v-icon medium @click="deletePackage(item.ID)" :disabled="currentItem.Status != receiptStatusEnum.chua_xuat">delete</v-icon>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                            <v-card-title v-else>Vui lòng lưu lại thông tin phiếu trước khi thêm danh sách mã vận đơn.</v-card-title>
                        </div>
                    </v-widget>
                </v-flex>
                <v-flex sm12 md12 lg12>
                    <v-widget title="Lịch sử phiếu xuất">
                        <div slot="widget-content">
                            <v-data-table fixed-header height= "70vh"  :headers="historical_headers" :items="historicals" disable-pagination hide-default-footer :loading="loading">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.CreatedDate | display_date }}</td>
                                        <td>{{ item.CreatedBy  }}</td>
                                        <td>{{ item.Content }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-widget>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <v-dialog v-model="packageDialog" max-width="500px" persistent>
        <v-card>
            <v-card-title>
                <span class="title">Xuất mã vận đơn</span>
            </v-card-title>
            <v-card-text>
            <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg12 md12 sm12>
                        <v-textarea 
                            label="Danh sách mã vận đơn (mỗi mã một dòng)" 
                            v-model="newTransactionCodes" 
                            rows="10"
                            class="input-group--focused"
                            hint="Nhập mỗi mã vận đơn trên một dòng"
                            persistent-hint
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1 white--text" @click="packageDialog = false">Hủy</v-btn>
                <v-btn color="blue darken-1 white--text" @click="addPackages" :loading="loading">Thêm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import { mapState } from "vuex";
import VWidget from "@/components/VWidget";
import configs from "@/configs";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { sendErrorNotice } from "@/commons/utils";
import { print_export_receipt_order } from '@/commons/hpod';
import _ from "lodash";
import moment from "moment";
export default {
    components: {
        VWidget,
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            ex_date: null,
            pay_date: null,
            newTransactionCodes: '',
            receiptStatus: configs.RECEIPT_STATUS,
            receiptType: configs.RECEIPT_TYPE,
            receiptTypeEnum: configs.RECEIPT_TYPE_ENUM,
            feeTypes: configs.FEE_TYPE,
            receiptStatusEnum: configs.RECEIPT_STATUS_ENUM,
            paymentMethods: configs.PAYMENT_METHODS,
            packageDialog: false,
            package_headers: [
                {
                    text: "STT",
                    sortable: false
                },
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "",
                }
            ],
            historical_headers: [
                {
                    text: "Ngày",
                    sortable: false
                },
                {
                    text: "Người thực hiện",
                    value: "CreatedBy",
                    sortable: false,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Nội dung",
                    value: "Content",
                    sortable: false,
                    dataType: configs.DATA_TYPE["String"]
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.exportReceipt.loading,
            currentItem: state => state.exportReceipt.selected,
            packages: state => state.exportReceipt.selected.Packages,
            historicals: state => state.exportReceipt.selected.Historicals,
            customers: state => state.customer.master.data,
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        calculatedAmount() {
            const item = this.currentItem;
            if (!item) return 0;
            
            const weight = item.Weight || 0;
            const volume = item.Volume || 0;
            const numberOfPack = item.NumberOfPack || 0;
            const price = item.Price || 0;
            const feeShipVND = item.FeeShipVND || 0;
            const vnFeeShip = item.VNFeeShip || 0;
            
            if (item.ReceiptType == 1) {
                // Phiếu chính ngạch
                const priceOfPack = item.PriceOfPack || 0;
                const vatRate = item.VatRate || 0;
                const exportRate = item.ExportRate || 0;
                const importRate = item.ImportRate || 0;
                const trusteeRate = item.TrusteeRate || 0;
                
                const goodsValue = priceOfPack * numberOfPack;
                const transportCost = weight * price;
                const vatAmount = goodsValue * vatRate / 100;
                const exportFee = goodsValue * exportRate / 100;
                const importFee = goodsValue * importRate / 100;
                const trusteeFee = goodsValue * trusteeRate / 100;
                
                return goodsValue + transportCost + vatAmount + exportFee + importFee + trusteeFee + feeShipVND + vnFeeShip;
            } else {
                // Phiếu thường
                if (item.FeeType == 1) {
                    return weight * price + feeShipVND + vnFeeShip;
                } else {
                    return volume * price + feeShipVND + vnFeeShip;
                }
            }
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        currentItem: {
            handler: function (val, oldVal) {
                this.ex_date = this.currentItem.ExportDate ? moment(this.currentItem.ExportDate).toISOString().substr(0, 10) : null;
                this.pay_date = this.currentItem.PaymentDate ? moment(this.currentItem.PaymentDate).toISOString().substr(0, 10) : null;
            },
            deep: true
        },
        calculatedAmount: {
            handler: function (newVal) {
                // Chỉ tự động cập nhật Amount khi chưa xuất kho
                if (this.currentItem && this.currentItem.Status == this.receiptStatusEnum.chua_xuat) {
                    this.currentItem.Amount = Math.round(newVal);
                }
            },
            immediate: false
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("exportReceipt/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("exportReceipt/setDetail", { data: { ID: 0, UID: 0, Amount: 0, Status: 1, FeeType: 1, ReceiptType: 0, VatRate: 0, ExportRate: 0, ImportRate: 0, TrusteeRate: 0, PriceOfPack: 0 } });
            }
        },
        openPackageDialog() {
            this.packageDialog = true;
        },
        deletePackage(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, 'Bạn muốn xóa mã vận đơn khỏi phiếu xuất?');
        },
        addPackages() {
            if(!this.newTransactionCodes.trim()) {
                sendErrorNotice('Vui lòng nhập danh sách mã vận đơn.');
                return;
            }
            
            // Parse danh sách mã vận đơn từ textarea
            const codes = this.newTransactionCodes
                .split('\n')
                .map(code => code.trim().toLowerCase())
                .filter(code => code !== '');
            
            if(codes.length === 0) {
                sendErrorNotice('Danh sách mã vận đơn trống.');
                return;
            }

            // Gửi danh sách mã lên backend
            this.$store.dispatch("exportReceipt/setDetail", {
                data: {
                    Action: 'add_packages',
                    TransactionCodes: codes
                },
                id: this.currentItem.ID
            }).then((ret) => {
                if(ret && ret.status === 200) {
                    const result = ret.data;
                    if(result.success && result.success.length > 0) {
                        this.$store.dispatch("exportReceipt/getDetail", this.currentItem.ID);
                        this.packageDialog = false;
                        this.newTransactionCodes = '';
                        
                        let message = `Đã thêm ${result.success.length} mã vận đơn thành công.`;
                        if(result.errors && result.errors.length > 0) {
                            message += `\n${result.errors.length} mã lỗi: ${result.errors.join(', ')}`;
                        }
                        this.$store.dispatch('app/showSuccess', message);
                    } else {
                        sendErrorNotice(result.errors ? result.errors.join('\n') : 'Không thể thêm mã vận đơn.');
                    }
                }
            }).catch(err => {
                sendErrorNotice('Có lỗi xảy ra khi thêm mã vận đơn.');
            });
        },
        saveData() {
            let payload = {
                ...this.currentItem,
                ExportDate: this.ex_date ? moment(this.ex_date, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
            }
            delete payload.Packages;
            delete payload.Historicals;
            this.$store.dispatch("exportReceipt/setDetail", {
                data: payload,
                id: this.currentItem.ID
            }).then((ret) => {
                ret = ret.data ? ret.data : ret;
                if(!_.isEmpty(ret) && ret.ID) {
                    this.$router.push({
                        name: "ExportReceiptDetail",
                        params: { Pid: ret.ID, title: `Chi tiết phiếu xuất (#${ret.ID})` }
                    });
                }
            });
        },
        onConfirmAction(action) {
            if(!this.currentItem.Price || (!this.currentItem.Weight && !this.currentItem.Volume)) {
                sendErrorNotice('Hãy nhập giá tiền và cân nặng.');
                return;
            }
            if(action == 'export_receipt_payment') {
                if(!this.currentItem.PaymentMethod) {
                    sendErrorNotice('Chọn hình thức thanh toán.');
                    return;
                }
                if(this.currentItem.Status == this.receiptStatusEnum.da_thanh_toan) {
                    sendErrorNotice('Phiếu xuất đã được thanh toán.');
                    return;
                }
                this.$store.dispatch("exportReceipt/setDetail", {
                    'data': {
                        Status: this.receiptStatusEnum.da_thanh_toan,
                        Amount: this.currentItem.Amount,
                        UID: this.currentItem.UID,
                        Username: this.currentItem.Username,
                        PaymentMethod: this.currentItem.PaymentMethod,
                        Action: 'payment'
                    },
                    id: this.currentItem.ID
                }).then((ret) => {
                    if(ret.status == 202) {
                        sendErrorNotice(ret.reason)                    
                    }
                });
            }
            else if(action == 'export_receipt_export') {
                if(this.currentItem.Status == this.receiptStatusEnum.da_xuat) {
                    sendErrorNotice('Phiếu đã được xuất kho.');
                    return;
                }
                if(this.currentItem.Packages.length == 0) {
                    sendErrorNotice('Phiếu xuất chưa có thông tin mã vận đơn.');
                    return;
                }
                this.$store.dispatch("exportReceipt/setDetail", {
                    'data': {
                        Status: this.receiptStatusEnum.da_xuat
                    },
                    'id': this.modifyId
                });
            }
        },
        onExportStore() {
            window.getApp.$emit('REQUEST_CONFIRM_ACTION', 'Bạn muốn xuất kho phiếu xuất?', 'export_receipt_export');
        },
        onPayment() {
            window.getApp.$emit('REQUEST_CONFIRM_ACTION', 'Bạn muốn thanh toán phiếu xuất?', 'export_receipt_payment');
        },
        onPrint() {
            const frame_printing = print_export_receipt_order(this.currentItem, this.packages, true, this.currentItem.ReceiptType == 1);
            var doc = document.getElementById("print_frame").contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function () {
                window.frames["print_frame"].window.print();
            }, 1000);
        },
        onCustomerChanged() {
            let selectedCustomer = _.find(this.customers, {'ID': this.currentItem.UID});
            this.currentItem.Username = selectedCustomer ? selectedCustomer.Username : '';
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
    },
    mounted() {
        this.getCustomerList();
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("REQUEST_CREATE_DATA", () => {
            this.onExportStore();
        });
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("orderTransaction/setDetail", {
                'data': {
                    ExportReceiptID: 0
                },
                'id': id
            });
        });
        this.$root.$on("CONFIRMED_ACTION", (item) => {
            this.onConfirmAction(item.action);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("CONFIRMED_ACTION");
    },
};
</script>